import HttpService from 'api/HttpService';
import {UserSellerService} from 'services/seller/modules/UserSellerService';
import {ShopSellerService} from 'services/seller/modules/ShopSellerService';
import {AccountSellerService} from 'services/seller/modules/AccountSellerService';
import {ProjectSellerService} from 'services/seller/modules/ProjectSellerService';
import {CampaignsSellerService} from 'services/seller/modules/CampaignsSellerService';
import {BidManagerAutostrategiesService} from 'services/BidManagerAutostrategiesService';
import {PlacementsService} from 'services/PlacementsService';
import {ConfigService} from 'services/ConfigService';
import {BidderPerformanceSellerService} from 'services/seller/modules/BidderPerformanceSellerService';


const userSellerService = new UserSellerService(HttpService);
const configService = new ConfigService(HttpService);
const shopSellerService = new ShopSellerService(HttpService);
const campaignsSellerService = new CampaignsSellerService(HttpService);
const autostrategySellerService = new BidManagerAutostrategiesService(HttpService);
const placementSellerService = new PlacementsService(HttpService);
const accountSellerService = new AccountSellerService(HttpService);
const projectSellerService = new ProjectSellerService(HttpService);
const bidderPerformanceSellerService = new BidderPerformanceSellerService(HttpService);

// todo: убрать
window.setMeta = (key, val = false) => userSellerService.setMeta({[key]: val});
window.setMetaAccount = (key, val = false) => userSellerService.setMetaProject({[key]: val});

export {
  userSellerService,
  configService,
  shopSellerService,
  campaignsSellerService,
  autostrategySellerService,
  placementSellerService,
  accountSellerService,
  projectSellerService,
  bidderPerformanceSellerService
};
